<template>
  <div name="demo-validate-validate-all">
    <hrms-timepicker  v-model="timstrt" 
                      v-validate="'requiredWhenExist:timend|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timstrt"
                      name="timstrt"
                      :has-error="errors.has('timstrt')" />
    <div class="text-error" v-show="errors.has('timstrt')">{{errors.first('timstrt')}}</div>
    <hrms-timepicker  v-model="timend" 
                      v-validate="'requiredWhenExist:timstrt|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timend"
                      name="timend"
                      :has-error="errors.has('timend')" />
    <div class="text-error" v-show="errors.has('timend')">{{errors.first('timend')}}</div>
    <input type="text" v-model="username"
         v-validate="'required'" 
         name="username" 
         data-vv-as="username" 
         placeholder="Username" 
         :class="{ 'input-error' : errors.has('username') }" />
    <div v-show="errors.has('username')" class="text-error">{{ errors.first('username') }}</div>
    <input type="text" v-model="dtereq"
         maxlength="10" 
         v-validate="'required|date_format:DD/MM/YYYY'" 
         name="dtereq" 
         data-vv-as="dtereq" 
         placeholder="DD/MM/YYYY" 
         :class="{ 'input-error' : errors.has('dtereq') }" />
    <div v-show="errors.has('dtereq')" class="text-error">{{ errors.first('dtereq') }}</div>
    <hrms-datepicker  v-model="dtework" 
                      v-validate="'required|date_format:DD/MM/YYYY'"
                      data-vv-value-path="inputDate"
                      data-vv-name="dtework"
                      name="dtework"
                      :has-error="errors.has('dtework')" />
    <div class="text-error" v-show="errors.has('dtework')">{{errors.first('dtework')}}</div>
    <button @click="validateFields()">Save</button>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-validate-all',
  data () {
    return {
      username: '',
      dtereq: '',
      timstrt: '',
      timend: ''
    }
  },
  watch: {
    timstrt () {
      this.$validator.validate('timend', this.timend).catch(e => {})
    },
    timend () {
      this.$validator.validate('timstrt', this.timstrt).catch(e => {})
    }
  },
  methods: {
    validateFields () {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            console.log('validate pass')
          }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoValidateValidateAll.vue?886ba1dc